import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { DescriptionDropdownComponent } from './description-dropdown.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [
    DescriptionDropdownComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    AngularSvgIconModule,
  ],
  exports: [
    DescriptionDropdownComponent,
  ],
  providers: [
    TranslatePipe,
  ]
})
export class DescriptionDropdownModule { }
